import { Field } from 'formik';
import React from 'react';
import { FiftyFiftyElement } from '../../components/FiftyFiftyElement';
import { marketing } from '../../constants';
import { EVO } from '../../EVO';
import { Question } from './Question';
import { PTErrors } from '../../components/PTElements';

export const NcdStep2 = props => {
    return (
        <div>
            <Question>Is this a Marketing message?</Question>
            <Field name="marketing" component={FiftyFiftyElement} options={EVO.getSelectItemFromObjectOfSelectItems(marketing)} />
            <PTErrors fields={['marketing']} />
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/pages/NotificationChore/NcdStep2.js